var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Input } from 'root/src/client/v2/common/components/ui/input';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Read-only field with a copy button; the button shows the success check when copied.
export const CopyField = ({ value, label, className }) => {
    const [copied, setCopied] = useState(false);
    const copy = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(value);
            setCopied(true);
            toast.success('Copied to clipboard');
            setTimeout(() => setCopied(false), 1500);
        }
        catch (e) {
            toast.error('Could not copy to clipboard');
        }
    });
    return (<div className={cn('space-y-1', className)}>
			{label && <span className="block text-[11px] font-medium text-muted-foreground">{label}</span>}
			<div className="flex items-center gap-2">
				<TooltipProvider delayDuration={300}>
					<Tooltip>
						<TooltipTrigger asChild>
							<Input readOnly value={value} onFocus={event => event.currentTarget.select()} className="min-w-0 text-[11px]"/>
						</TooltipTrigger>
						<TooltipContent className="max-w-[320px] break-all">{value}</TooltipContent>
					</Tooltip>
				</TooltipProvider>
				<Button type="button" variant="outline" size="sm" success={copied} onClick={copy} aria-label="Copy to clipboard" className="h-9 flex-shrink-0 gap-1.5 rounded-lg px-3 text-[11px]">
					<ContentCopyIcon sx={{ fontSize: 14 }}/>
					Copy
				</Button>
			</div>
		</div>);
};
